// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__yy_mt","ring":"style_ring__y2MNk","ldsRingDefault":"style_lds-ring-default__ace8u","min":"style_min__p050R"};